

import { Injectable, Optional } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  getAllUsers() {
    throw new Error('Method not implemented.');
  }

  manage_projects_customerData: any = []
  selectedCustomerIds: any = [];
  filteredCustomerList: any = []
  smartsyncTableList: any = []
  smartsyncformdata: any = {}
  FinalMoqData: any = []
  FinalMoqD: any = {}
  showMOQSection: boolean = false
  smartsyncTabContainer: string = "syncVolumeContainer"
  testBack = new Subject<any>();
  testBackSend(data: any) {
    this.testBack.next(data)
  }
  testBackrecive() {
    return this.testBack.asObservable()
  }
  tablereprestation: any = {}



  baseUrl = environment.apiUrl;
  // private readonly demoRfqAuthUrl = 'https://demo-tras.getapcs.com:8040/api/Login/GenerateUserToken';
  // private readonly demoRfqReleasedListUrl = 'https://demo-tras.getapcs.com:8043/api/Rfq/GetSoucingFGBomChildItemDetails';
  // private readonly demoRfqUpdateUrl = 'https://demo-tras.getapcs.com:8043/api/RfqSourcing/UpdateSoucingRfqSourcing';
  private readonly demoRfqAuthUrl = 'https://ngp-demo-master.getapcs.com/api/Login/GenerateUserToken';
  private readonly demoRfqReleasedListUrl = 'https://ngp-demo-sales.getapcs.com/api/Rfq/GetSoucingFGBomChildItemDetails';
  private readonly demoRfqUpdateUrl = 'https://ngp-demo-sales.getapcs.com/api/RfqSourcing/UpdateSoucingRfqSourcing';

  private readonly trassconRfqAuthUrl = 'https://trasccon.getapcs.com:8003/api/Login/GenerateUserToken';
  // private readonly trassconRfqReleasedListUrl = 'https://trasccon.getapcs.com:8006/api/Rfq/GetSoucingFGBomChildItemDetails';
  // private readonly trassconRfqUpdateUrl = 'https://trasccon.getapcs.com:8006/api/RfqSourcing/UpdateSoucingRfqSourcing';
  private readonly trassconRfqReleasedListUrl = 'https://demo-tras.getapcs.com:8043/api/Rfq/GetSoucingFGBomChildItemDetails?RfqNumber=TISPL-4829';
  private readonly trassconRfqUpdateUrl = 'https://demo-tras.getapcs.com:8043/api/RfqSourcing/UpdateSoucingRfqSourcing';

  private get rfqConfig() {
    const currentBaseUrl = (this.baseUrl || '').toLowerCase();
    const isTrassconInstance = currentBaseUrl.includes('trasccon') || currentBaseUrl.includes('trasscon');

    return isTrassconInstance
      ? {
        authUrl: this.trassconRfqAuthUrl,
        releasedListUrl: this.trassconRfqReleasedListUrl,
        updateUrl: this.trassconRfqUpdateUrl,
        password: 'AATr@ns@2026'
      }
      : {
        authUrl: this.demoRfqAuthUrl,
        releasedListUrl: this.demoRfqReleasedListUrl,
        updateUrl: this.demoRfqUpdateUrl,
        password: 'Keusadmin@2025'
      };
  }

  constructor(
    private httpClient: HttpClient,
    @Optional() private notify: NbToastrService
  ) { }

  // =====================================================================
  // GET METHODS
  // =====================================================================

  getAllProjectViewInfoData(user_id: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/getAlldetails/${user_id}`);
  }

  engineers(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/engineers`);
  }

  get_frequency(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_frequency`);
  }

  fetchNotifications(userId: number | string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/fetch_notifications/${userId}`);
  }

  markNotificationRead(notificationId: number | string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/mark_notification_read/${notificationId}`, { notification_id: notificationId });
  }

  calculate_freight_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_freight_matrix`);
  }

  calculate_duty_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_duty_matrix`);
  }

  // =====================================================================
  // IMPORT DUTIES APIS (/api/duties)
  // =====================================================================

  getDuties(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
          httpParams = httpParams.set(key, val.toString());
        }
      });
    }
    return this.httpClient.get(`${this.baseUrl}/api/duties`, { params: httpParams });
  }

  createDuty(payload: {
    category: string;
    hsn_code?: string;
    basic_customs_duty?: number;
    sws?: number;
    igst?: number;
    total_effective_duty?: number;
  }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/api/duties`, payload);
  }

  updateDuty(dutyId: number | string, payload: {
    category?: string;
    hsn_code?: string;
    basic_customs_duty?: number;
    sws?: number;
    igst?: number;
    total_effective_duty?: number;
  }): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/api/duties/${dutyId}`, payload);
  }

  deleteDuty(dutyId: number | string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/api/duties/${dutyId}`);
  }

  uploadDuties(file: File, mode: string = 'upsert'): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    let params = new HttpParams().set('mode', mode);
    return this.httpClient.post(`${this.baseUrl}/api/duties/upload`, formData, { params });
  }

  downloadDutyTemplate(): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/api/duties/template`, {
      responseType: 'blob'
    });
  }

  // =====================================================================
  // FREIGHT MATRIX APIS (/api/freight)
  // =====================================================================

  getFreight(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
          httpParams = httpParams.set(key, val.toString());
        }
      });
    }
    return this.httpClient.get(`${this.baseUrl}/api/freight`, { params: httpParams });
  }

  createFreight(payload: {
    Region: string;
    Country: string;
    CountryCode?: string;
    AirFreightCharge?: number;
    SeaFreightCharge?: number;
  }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/api/freight`, payload);
  }

  updateFreight(freightId: number | string, payload: {
    Region?: string;
    Country?: string;
    CountryCode?: string;
    AirFreightCharge?: number;
    SeaFreightCharge?: number;
  }): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/api/freight/${freightId}`, payload);
  }

  deleteFreight(freightId: number | string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/api/freight/${freightId}`);
  }

  uploadFreight(file: File, mode: string = 'upsert'): Observable<any> {
    const formData = new FormData();
    formData.append('file', file, file.name);
    let params = new HttpParams().set('mode', mode);
    return this.httpClient.post(`${this.baseUrl}/api/freight/upload`, formData, { params });
  }

  downloadFreightTemplate(): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/api/freight/template`, {
      responseType: 'blob'
    });
  }

  // =====================================================================
  // CURRENCY CONVERSION APIS (/currency)
  // =====================================================================

  getCurrencies(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
          httpParams = httpParams.set(key, val.toString());
        }
      });
    }
    return this.httpClient.get(`${this.baseUrl}/currency`, { params: httpParams });
  }

  createCurrency(payload: {
    currency_code: string;
    currency_rate: number;
    currency_name: string;
    currency_country: string;
  }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/currency`, payload);
  }

  updateCurrency(identifier: string | number, payload: {
    currency_rate?: number;
    currency_name?: string;
    currency_country?: string;
    currency_code?: string;
  }): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/currency/${identifier}`, payload);
  }

  deleteCurrency(identifier: string | number): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/currency/${identifier}`);
  }

  getSuppliers(skip: number = 0, limit: number = 10): Observable<any> {
    let url = `${this.baseUrl}/suppliers?skip=${skip}&limit=${limit}`;
    return this.httpClient.get(url);
  }

  getSupplierById(supplierId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/suppliers/${supplierId}`);
  }

  getPurchaseOrders(skip = 0, limit = 10, supplierId?: string): Observable<any[]> {
    let url = `${this.baseUrl}/purchase-orders?skip=${skip}&limit=${limit}`;
    if (supplierId) {
      url += `&supplier_id=${supplierId}`;
    }
    return this.httpClient.get<any[]>(url);
  }

  getEmailTemplateCategories(skip: number = 0, limit: number = 50): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/email-template-categories?skip=${skip}&limit=${limit}`);
  }

  // getOfflineVendorSourcing(project_id: string, version_id: string): Observable<any> {
  //   return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/${project_id}/${version_id}`);
  // }
  getOfflineVendorSourcing(project_id: string, version_id: number, procurement_version_id: number = 0): Observable<any> {

    return this.httpClient.get(
      `${this.baseUrl}/offline_vendor_sourcing/${project_id}/${version_id}/${procurement_version_id}`
    );
  }
  getEmailTemplates(skip: number = 0, limit: number = 10, category: string = ''): Observable<any> {
    let url = `${this.baseUrl}/email-templates?skip=${skip}&limit=${limit}`;
    if (category) {
      url += `&category=${category}`;
    }
    return this.httpClient.get<any>(url);
  }

  getCategories(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_templates`);
  }

  getEmailTemplatesid(templateName: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_templates?templateName=${templateName}`);
  }

  getSampleEmailTemplate(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_template`);
  }

  searchSuppliers(search: string, skip: number = 0, limit: number = 10): Observable<any> {
    const url = `${this.baseUrl}/suppliers/search?search=${search}&skip=${skip}&limit=${limit}`;
    console.log('searchSuppliers =>', url);
    return this.httpClient.get(url);
  }

  getEmailTemplateCollections(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email-template-collections`);
  }

  getEmailTemplateMetaFields(collection: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email-meta-fields`, {
      params: { collection_name: collection }
    });
  }

  downloadFileWithAuth(fileId: string): Observable<Blob> {
    const url = `${this.baseUrl}/download_file/${fileId}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  fetchCurrencyUploadHistory(limit: number = 10): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/fetch_currency_upload_history?limit=${limit}`);
  }

  getEmailTemplatesByCategory(category: string): Observable<any> {
    const params: any = {
      skip: 0,
      limit: 10,
      category
    };
    return this.httpClient.get(`${this.baseUrl}/email-templates`, { params });
  }

  getRfqFollowups(rfqId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}`);
  }

  // getInputSourceDropdown(projectId: number, versionId: number): Observable<any> {
  //   return this.httpClient.get(
  //     `${this.baseUrl}/get_Input_source_data/projects/${projectId}/versions/${versionId}/dropdown-options`
  //   );
  // }
  getInputSourceDropdown(
    projectId: number,
    versionId: number,
    procurementVersionId: number = 0
  ): Observable<any> {

    return this.httpClient.get(
      `${this.baseUrl}/get_Input_source_data/projects/${projectId}/versions/${versionId}/procurement/${procurementVersionId}/dropdown-options`
    );
  }
  // =====================================================================
  // POST METHODS
  // =====================================================================

  geAllsourcingParts({ }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sourcingParts/`, {});
  }

  getParts_offer_details(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/getParts_offer_details/`, data);
  }

  login(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/login`, data);
  }

  add_project(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_project`, data);
  }

  manage_projects(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_projects/`, data).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Request Failed:', error);
        let errorMessage = 'Something went wrong. Please try again.';
        if (error.status === 500) {
          errorMessage = 'Server error: 500 Internal Server Error. Please try again later.';
        } else if (error.status === 0) {
          errorMessage = 'Network error: Unable to reach the server.';
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        }
        this.notify?.danger(errorMessage);
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  add_customer(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_customer`, data);
  }

  all_customers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_customers/`, data);
  }

  create_customers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/customers/create`, data);
  }

  createCustomer(payload: {
    customerName: string;
    city?: string;
    state?: string;
    country?: string;
    gstNumber?: string;
  }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/customer/create`, payload);
  }

  get_manager_and_engineers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_manager_and_engineers/`, data);
  }

  get_Projectview(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_Projectview`, payload);
  }

  get_Projectview_part(project_id: number, version_id: number): Observable<any> {
    const url = `${this.baseUrl}/get_Projectview`;
    const payload = {
      project_id,
      version_id
    };
    return this.httpClient.post(url, payload);
  }

  get_project_part_details_Top_N_Seller(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_project_part_details_Top_N_Seller`, data);
  }

  finalCompareData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/trigger_sourcing_parts_task`, parts);
  }

  getRfqEnggReleasedList(payload: { RfqNumber: string; RevisionNumber?: any }): Observable<any> {
    const authPayload = {
      userName: 'admin@mail.com',
      password: this.rfqConfig.password,
      unitName: 'Bangalore'
    };

    return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
      switchMap((tokenResponse: any) => {
        const token = this.extractGeneratedToken(tokenResponse);
        if (!token) {
          return throwError(() => new Error('Authentication token not found in token response.'));
        }

        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`
        });

        const params: any = {
          RfqNumber: payload.RfqNumber
        };
        if (payload.RevisionNumber !== undefined && payload.RevisionNumber !== null && payload.RevisionNumber !== '') {
          params.RevisionNumber = payload.RevisionNumber;
        }

        return this.httpClient.get<any>(this.rfqConfig.releasedListUrl, {
          headers,
          params
        });
      })
    );
  }

  private extractGeneratedToken(response: any): string | null {
    if (!response) {
      return null;
    }

    if (typeof response === 'string') {
      return response;
    }

    return (
      response?.token ||
      response?.accessToken ||
      response?.data?.token ||
      response?.data?.accessToken ||
      response?.data?.tokenString ||
      response?.result?.token ||
      response?.result?.accessToken ||
      response?.data?.[0]?.token ||
      response?.data?.[0]?.accessToken ||
      null
    );
  }

  get_ProjectviewWithProjectIdAndVersionId(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_Projectview`, data);
  }

  get_projects_comparison_dropdown(data: any): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_projects_comparison_dropdown/`, { params: data });
  }

  get_offer_price(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_offer_price`, data);
  }

  add_user(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_users`, data);
  }

  get_All_roles({ }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/Getrolemaster`, {});
  }

  update_Finalise_project_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/UpdateFinaliseProjectPart`, data);
  }

  manufacturer_Name_search(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manufacturer_Name_search`, data);
  }

  sync_project_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_part`, data);
  }

  calculate_duty_cost(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/calculate_duty_cost/`, data);
  }

  get_sync_consolidation_parts(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sync_consolidation_parts`, data);
  }

  create_part_alert(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/create_part_alert`, data);
  }

  list_parts_alert(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/list_parts_alert`, data);
  }

  save_sync_cosolidate_final_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/save_sync_cosolidate_final_part`, data);
  }

  fetch_sync_cosolidate_final_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/fetch_sync_consolidation_final_part`, data);
  }

  analyze_html(data: any): Observable<any> {
    return this.httpClient.post(`${'https://ai.syntheta.net/api/analyze/html'}`, data);
  }

  sync_project_parts_moq(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_parts_moq`, data);
  }

  uploadPoData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/purchase-orders/upload`, parts);
  }

  uploadVendorData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/suppliers/upload`, parts);
  }

  fetchPartDetails(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/fetch-part-details`, payload);
  }

  createSupplier(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/suppliers`, payload);
  }

  uploadAttachments(internalPartNo: string, files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });
    formData.append('internalPartNo', internalPartNo);
    return this.httpClient.post(`${this.baseUrl}/upload_files`, formData);
  }

  uploadFilesForAIScrubbing(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });
    return this.httpClient.post(`${this.baseUrl}/upload_files`, formData);
  }

  matchFiles(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/match`, payload);
  }

  matchEolStatus(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/match-eolstatus`, payload);
  }

  mpnCheck(payload: { mpn: string; manufacturer: string }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/mpn-check`, payload);
  }

  submitRFQ(payload: any, sendEmail: boolean = true): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrl}/offline_vendor_sourcing/create?send_email=${sendEmail}`,
      payload
    );
  }

  createEmailTemplate(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/email-templates`, payload);
  }

  getPartPriceHistoryInternal(internalPartNo: string, projectId: any, versionId: number, commodity: string, procurementVersionId: number = 0): Observable<any> {
    const body = {
      internalPartNumber: internalPartNo,
      project_id: projectId,
      version_id: versionId,
      procurement_version_id: procurementVersionId,
      commodity: commodity
    };
    return this.httpClient.post(`${this.baseUrl}/part_history_ipn`, body);
  }

  getCustomers(params?: any): Observable<any> {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach(key => {
        const val = params[key];
        if (val !== undefined && val !== null && val !== '') {
          httpParams = httpParams.set(key, val.toString());
        }
      });
    }
    return this.httpClient.get(`${this.baseUrl}/customer`, { params: httpParams });
  }

  // =====================================================================
  // PUT METHODS
  // =====================================================================

  updateSupplier(supplierId: string, supplierData: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/suppliers/${supplierId}`, supplierData);
  }

  updateSourcingParts(payload: any): Observable<any> {
    const url = `${this.baseUrl}/offline_vendor_sourcing/parts/update`;
    return this.httpClient.put(url, payload);
  }

  updateEmailTemplate(id: string, payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/email-templates/${id}`, payload);
  }

  sendRfqEmail(rfqId: string, payload: any, sendEmailFlag: boolean): Observable<any> {
    return this.httpClient.put(
      `${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}?send_email_flag=${sendEmailFlag}`,
      payload
    );
  }

  updateCustomer(customerIdOrPayload: any, payload?: any): Observable<any> {
    if (payload !== undefined) {
      return this.httpClient.put(`${this.baseUrl}/customers/${customerIdOrPayload}`, payload);
    }
    if (typeof customerIdOrPayload === 'object' && customerIdOrPayload !== null) {
      const id = customerIdOrPayload.id;
      const body = { ...customerIdOrPayload };
      delete body.id;
      return this.httpClient.put(`${this.baseUrl}/customers/${id}`, body);
    }
    return this.httpClient.put(`${this.baseUrl}/customers/${customerIdOrPayload}`, payload);
  }

  // =====================================================================
  // DELETE METHODS
  // =====================================================================

  delete_part_alert(job_id: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/delete_part_alert/${job_id}`);
  }

  deleteSupplier(supplierId: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/suppliers/${supplierId}`);
  }

  deleteEmailTemplate(id: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/email-templates/${id}`);
  }

  softDeleteCustomer(customerId: number): Observable<any> {
    return this.httpClient.delete(
      `${this.baseUrl}/customers/soft_delete/${customerId}`
    );
  }

  Delete_part(payload: any): Observable<any> {
    return this.httpClient.delete(
      `${this.baseUrl}/delete-part`,
      {
        body: payload
      }
    );
  }
  dashboardHierarchy(payload: any) {
    return this.httpClient.post<any>(
      `${this.baseUrl}/hierarchy-dashboard/dashboard`,
      payload
    );
  }
  getAgeingSummary(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/ageing-summary`,
      { params }
    );
  }
  getEngineerWiseProjectSummary(managerId: number) {
    return this.httpClient.get<any>(
      ` ${this.baseUrl}/hierarchy-dashboard/manager-dashboard/engineer-wise-project-summary`,
      {
        params: {
          manager_id: managerId
        }
      }
    );
  }
  getTopSuppliers(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/top-suppliers`,
      { params }
    );
  }

  // getImportStatusCommodityWise(params: any) {
  //   return this.httpClient.get<any>(
  //     `${this.baseUrl}/hierarchy-dashboard/import-status-commodity-wise`,
  //     { params }
  //   );
  // }

  getCompletionSummary(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/completion-summary`,
      { params }
    );
  }
  getMasterDataStatus() {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/master-data-status`
    );
  }

  getOfflineOnlineSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/online-offline-summary`,
      { params }
    );
  }
  getSupplierPaymentSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/supplier-payment-summary`,
      { params }
    );
  }

  getPartPricing(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/part-pricing`,
      { params }
    );
  }

  getCostByCurrency(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/cost-by-currency`,
      { params }
    );
  }

  getHierarchyLeadtime(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/leadtime`,
      { params }
    );
  }
  getSmartSyncSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/smart-sync-summary`,
      { params }
    );
  }

  getCostSavings(params: any) {
    return this.httpClient.get<any[]>(
      `${this.baseUrl}/hierarchy-dashboard/cost-savings`,
      { params: params as any }
    );
  }
  getQuantityDiff(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/quantity-diff`,
      { params }
    );
  }
  uploadExchangeRates(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(
      `${this.baseUrl}/upload_exchange_rates`,
      formData
    );
  }

  updateExchangeRates(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(
      `${this.baseUrl}/update_exchange_rates`,
      formData
    );
  }

  updateSourcingRfq(payload: any): Observable<any> {
    const url = this.rfqConfig.updateUrl;
    const authPayload = {
      userName: 'admin@mail.com',
      password: this.rfqConfig.password,
      unitName: 'Bangalore'
    };

    return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
      switchMap((tokenResponse: any) => {
        const token = this.extractGeneratedToken(tokenResponse);
        if (!token) {
          return throwError(() => new Error('Authentication token not found in token response.'));
        }

        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        });

        return this.httpClient.put<any>(url, payload, { headers }).pipe(
          catchError((error: HttpErrorResponse) => {
            // If 401 Unauthorized, try to get a new token and retry
            if (error.status === 401) {
              console.warn('Token expired (401), attempting to refresh token...');
              return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
                switchMap((newTokenResponse: any) => {
                  const newToken = this.extractGeneratedToken(newTokenResponse);
                  if (!newToken) {
                    return throwError(() => new Error('Failed to refresh authentication token.'));
                  }

                  const newHeaders = new HttpHeaders({
                    'Authorization': `Bearer ${newToken}`,
                    'Content-Type': 'application/json'
                  });

                  return this.httpClient.put<any>(url, payload, { headers: newHeaders });
                })
              );
            }
            return throwError(() => error);
          })
        );
      })
    );
  }

  // getPartPriceHistoryInternal1(internalPartNo: string) {
  //   return this.httpClient.get(`${this.baseUrl}/part_history_ipn?internalPartNumber=${internalPartNo}`);
  // }
  // get_project_parts_part_details_Top_N_Seller(data: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/get_project_parts_part_details_Top_N_Seller`, data);
  // }

  UpdateProjectPartMargin(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/UpdateProjectPartMargin`, data);
  }

  getProjectStatuses(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/project_statuses/`);
  }

  /**
   * Upload BOM files for Technical Engineer BOM Craft
   * POST /tech_bom_craft/files/upload
   */
  uploadTechBomFiles(formData: FormData): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/tech_bom_craft/files/upload`, formData);
  }

  /**
   * Clean BOM data using uploaded fileId and fileName
   * POST /tech_bom_craft/bomcleaning
   * Payload: { project_id, project_name, version_id, procurement_version_id, manager_id, engineer_id, files: [{ fileId, fileName }] }
   */
  cleanTechBom(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/tech_bom_craft/bomcleaning`, payload);
  }

  /**
   * Source cleaned records for Technical Engineer BOM Craft (BOM Assessment)
   * POST /tech_bom_craft/source-cleaned-records
   * Payload: { project_id, project_name, version_id, procurement_version_id, manager_id, engineer_id, records: [...] }
   */
  sourceCleanedRecords(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/tech_bom_craft/source-cleaned-records`, payload);
  }

  /**
   * Find component alternates using Gemini LLM
   * POST /tech_bom_craft/alternates/geminillm
   * Payload: { project_id, project_name, version_id, procurement_version_id, manager_id, engineer_id, mpn, manufacturer, force_refresh }
   */
  getGeminiAlternates(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/tech_bom_craft/alternates/geminillm`, payload);
  }

  /**
   * Find alternates for Technical Engineer BOM Craft
   * POST /tech_bom_craft/get-alternates
   * Payload: { project_id, project_name, version_id, procurement_version_id, manager_id, engineer_id, mpn, manufacturer, force_refresh }
   */
  getTechBomAlternates(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/tech_bom_craft/get-alternates`, payload);
  }

  /**
   * Submit technician workflow
   * POST /api/workflow/technician/submit
   * Payload: { project_id, version_id, procurement_version_id, technician_id, comments, cleaned_parts_count, parts, cleaned_records, data, sourcing_type }
   */
  submitTechnicianWorkflow(payload: {
    project_id: number;
    version_id: number;
    procurement_version_id?: number;
    technician_id: number;
    comments: string;
    cleaned_parts_count: number;
    parts?: any[];
    cleaned_records?: any[];
    data?: any[];
    sourcing_type?: string[];
    [key: string]: any;
  }): Observable<any> {
    const cleanBase = (this.baseUrl || '').replace(/\/+$/, '');
    const endpoint = cleanBase.endsWith('/api') ? '/workflow/technician/submit' : '/api/workflow/technician/submit';
    return this.httpClient.post(`${cleanBase}${endpoint}`, payload);
  }

  /**
   * Get Technical BOM Craft history / extracted records
   * GET /tech_bom_craft/history
   * Query params: project_id, project_name, version_id, procurement_id, procurement_version_id,
   *               created_by, manager_id, assign_to, assigned_to, engineer_id, endpoint, limit
   */
  getTechBomHistory(params?: any): Observable<any> {
    const cleanBase = (this.baseUrl || '').replace(/\/+$/, '');
    return this.httpClient.get(`${cleanBase}/tech_bom_craft/history`, { params });
  }

  /**
   * POST /input_source_data/details
   * Payload: { project_id: number, version_id: number, procurement_version_id: number }
   */
  getInputSourceDataDetails(payload: any): Observable<any> {
    const cleanBase = (this.baseUrl || '').replace(/\/+$/, '');
    return this.httpClient.post(`${cleanBase}/input_source_data/details`, payload);
  }
}


